export default "__VITE_ASSET__1Dlv9T48__"